<div class="row">
  <div *ngFor="let metadato of metadati">
    <div [ngSwitch]="metadato.type.id">

      <div *ngSwitchCase='"DATE"'>
        <div labelTextInput class="col-xs-12 col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="metadato.name"
        [valueInput]="metadato.value | date:'dd/MM/yyyy'"></div>
      </div>

      <div *ngSwitchCase='"BINARY_CURSOR"'>
        <div labelTextInput class="col-xs-12 col-sm-6 bloccodati" [typeLabel]="'text'" [labelInput]="metadato.name"
          [valueInput]="metadato.value === 'true' ? 'Si' : 'No'" >
        </div>
      </div>

      <div *ngSwitchCase='"TEXT_LONG"'>
        <div labelTextInput class="col-xs-12 col-sm-12 bloccodati" [typeLabel]="'textarea'" [labelInput]="metadato.name"
        [valueInput]="metadato.value" [title]="metadato.value">
        </div>
      </div>

      <div *ngSwitchDefault>
        <div labelTextInput class="col-xs-12 col-sm-6 bloccodati"  [typeLabel]="'text'" [labelInput]="metadato.name"
          [valueInput]="metadato.value" [title]="metadato.value"></div>
      </div>

    </div>
  </div>
</div>
